import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackTranslationProtectionApplied.meta';

export type UseTrackTranslationProtectionAppliedParams = {
  protected_regions_drawn: number;
  areas_skipped: boolean;
  areas_excluded_by_region: boolean;
};

export const useTrackTranslationProtectionApplied = () => {
  const { track } = useAnalyticsUtilities();

  const trackTranslationProtectionApplied = useCallback(
    (params: UseTrackTranslationProtectionAppliedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackTranslationProtectionApplied };
};
